import React, {useEffect, useState} from 'react';

const Email = ({children}) => {
  const [init, setInit] = useState(false);
  useEffect(() => {
    setInit(true);
  }, []);
  if (init === false) {
    return null;
  }
  // children from mdx
  const {props} = children;

  return <a href={`mailto:${props.children}`}>{props.children}</a>;
};

export default Email;
